module.exports = __webpack_public_path__ + "img/row2_col2_dfs.ed50243d.svg";